/**
 * @file history
 * @author 简单的history api，主要是对HTML5 History API的包装，为ssr留出可控制的地方。
 */

const global = window;
const eventType = 'popstate';

import { EventEmitterWrapper } from '@umu/umu-util';

export interface IChangeEvent {
    location: Location;
    action: string;
}

export default class History extends EventEmitterWrapper {
    public location: Location;

    constructor() {
        super();
        this.location = global.location;
        this.onPopState = this.onPopState.bind(this);
        this.onPopState();
    }

    public onPopState() {
        global.addEventListener(
            eventType,
            (event) => {
                const location: Location = this.location;
                const action: string = event.state || 'POP';
                const changEvent: IChangeEvent = { location, action };
                this.emit(eventType, changEvent);
            },
            false,
        );
    }

    public listen(listener: (...args: any[]) => any): () => void {
        this.on(eventType, listener);
        const unlisten = () => {
            this.off(eventType, listener);
        };
        return unlisten;
    }
}
